import React, { useState } from "react"
import { Col, Container, Row, Table } from "react-bootstrap"
import { useNavigate, useParams } from "react-router-dom"
import toast from "react-hot-toast"
import moment from "moment"
import Modal from "antd/es/modal/Modal"
// components
import PIModal from "./PIModal"

// utils, assets, & styles
import { getSuppliesInvoice } from "../../../../Helpers/apiCalls/Expenses/suppliesInvoiceApi"
import {
  dateFormat,
  formatDate,
  formatDateNoTime,
  formatDateSlash,
  getName,
  getTodayDateISO,
  numberFormat,
  numberFormatInt,
  refreshPage,
  toastStyle,
  TokenExpiry,
} from "../../../../Helpers/Utils/Common"
import ElmhurstLogo from "../../../../Assets/Images/elmhurst-initial-logo.png"
import cleanLogo from "../../../../Assets/Images/Login/transparent_bg.png"
import Navbar from "../../../../Components/Navbar/Navbar"
import TablePagination from "../../../../Components/TableTemplate/Table"
import { getSEPaymentHistory } from "../../../../Helpers/apiCalls/Expenses/sePurchaseApi"
import noDataImg from "../../../../Assets/Images/no-data-img.png"
import Footer from "../../../../Components/Footer/Footer"

export default function PrintPurchaseInvoice() {
  const { id } = useParams()
  let navigate = useNavigate()

  const [inactive, setInactive] = useState(true)
  const [paymentInfo, setPaymentInfo] = useState([])
  const [printPI, setPrintPI] = useState([])
  const [items, setItems] = useState([])

  async function fetchPI() {
    setPrintPI({})
    setItems([])

    const response = await getSuppliesInvoice(id)

    if (response.error) {
      TokenExpiry(response)
    } else {
      setPrintPI(response.data.data[0])
      setFileList(response.data.data[0].supplies_receive_attachments)
      setItems(response.data.data[0].supplies_receive_items)
    }
  }

  async function fetchSEPaymentHistory() {
    const response = await getSEPaymentHistory(id)

    if (response.data) {
      var history = response.data.data

      var allPayments = history.map((payment) => {
        var info = payment
        info.payment_date = dateFormat(payment.date)
        info.type = payment.payment_mode
        info.details =
          payment.payment_mode === "check"
            ? payment.payment_mode + " - " + payment.check_no
            : payment.payment_mode === "bank"
            ? payment.payment_mode + " - " + payment.reference_no
            : payment.payment_mode
        info.amount = payment.amount || "N/A"
        return info
      })
      setPaymentInfo(allPayments)
    }
  }

  const [fileList, setFileList] = useState([])
  const [preview, setPreview] = useState(false)
  const [previewFile, setPreviewFile] = useState("")

  /* print modal handler */
  const [showPrintModal, setShowPrintModal] = useState(false)
  const handleShowPrintModal = () => setShowPrintModal(true)
  const handleClosePrintModal = () => setShowPrintModal(false)

  async function handlePrintPI() {
    toast.loading("Printing Invoice", { style: toastStyle() })
    handleClosePrintModal()
    setTimeout(() => {
      toast.dismiss()
      Print()
    }, 1000)
  }

  function renderTable() {
    return (
      <Table className="align-middle">
        <thead>
          <tr>
            <th></th>
            {/* <th>Item Code</th> */}
            <th>Item Name</th>
            <th>U o M</th>
            {/* <th>Size</th> */}
            <th>Quantity</th>
            {/* <th>Discount</th> */}
            <th>Price/Unit</th>
            <th>Amount</th>
            <th>Remarks</th>
          </tr>
        </thead>
        <tbody>
          {items?.map((item, index) => {
            return (
              <tr key={index} className="req-table-w-border-bottom">
                <td className="req-table-w-border-sides">{index + 1}</td>
                {/* <td className="req-table-w-border-sides">{item.item_code}</td> */}
                <td className="req-table-w-border-sides">{item.name}</td>
                <td className="text-lowercase req-table-w-border-sides">
                  {item.unit}
                </td>
                {/* <td className="req-table-w-border-sides">{item.item_size}</td> */}
                <td className="req-table-w-border-sides">{item.qty}</td>
                {/* <td className="req-table-w-border-sides">{numberFormat(item.discount_amount)} ({parseFloat(item.discount_percentage).toFixed(0)}%)</td> */}
                <td className="req-table-w-border-sides">
                  {numberFormat(item.price)}
                </td>
                <td className="req-table-w-border-sides">
                  {numberFormat(item.total)}
                </td>
                <td className="req-table-w-border-sides">{item.remarks}</td>
              </tr>
            )
          })}
        </tbody>
      </Table>
    )
  }

  function Print() {
    let printContents = document.getElementById("printablediv").innerHTML
    let originalContents = document.body.innerHTML
    document.body.innerHTML = printContents
    window.print(printContents)
    document.body.innerHTML = originalContents
    refreshPage()
  }

  React.useEffect(() => {
    fetchPI()
    fetchSEPaymentHistory()
  }, [])

  console.log(printPI)

  return (
    <div>
      <div className="page">
        <Navbar
          onCollapse={(inactive) => {
            setInactive(inactive)
          }}
          active={"SUPPLIES"}
        />
      </div>
      <div className={`manager-container ${inactive ? "inactive" : "active"}`}>
        <br />
        <br />
        <div className="print-container px-3 py-2" id="printablediv">
          <div className="print-header-elm d-flex">
            <div className="w-full">
              <div className="print-top d-flex py-1">
                <img src={ElmhurstLogo} className="print-logo-elm" alt="" />
              </div>
              <div className="print-top">
                {/* <h1 className="print-shop-header d-flex justify-content-start">ELMHURST ENTERPRISES</h1> */}
                <h5 className="print-shop-header-elm d-flex justify-content-start print-data">
                  497 D MOLAVE EXTENSION, LAHUG, CEBU CITY
                </h5>
                {/* <h5 className="print-shop-header-elm d-flex justify-content-start">San Roque, Cebu City</h5> */}
              </div>
            </div>
            <div className="purchase-order-number-print-container w-full">
              <h1 className="purchase-order-title-print-elm">
                EXPENSE INVOICE
              </h1>
              <div className="po-date-elm">
                <div className="po-date-and-number">
                  <h5 className="print-shop-header-elm d-flex text-alignment print-data">
                    PO Date: {dateFormat(printPI.purchase_date)}
                  </h5>
                  <h5 className="print-shop-header-elm d-flex text-alignment print-data">
                    {" "}
                    P.O No.: {printPI.supplies_expense_id}
                  </h5>
                </div>
              </div>
            </div>
          </div>

          <div className="supplier-address-container">
            {/* <h2 className="supplier-title-elm">Supplier</h2> */}
            <h4 className="print-shop-header-elm supplier-name-elm d-flex justify-content-start print-data fs-5">
              Supplier: {printPI.supplier_name}
            </h4>
            {/* <h5 className="print-shop-header-elm d-flex justify-content-start">
                        {printPI.delivery_address}
                        </h5> */}
          </div>

          {/* content */}
          <div className="mt-5">
            <Row>
              <Col xs={6} lg={5} md={6} className="split-columns">
                <div className="d-flex my-2 align-items-center">
                  <Col xs={4} className="print-label">
                    Branch:
                  </Col>
                  <Col xs={5} className="print-data">
                    {printPI.branch_name}
                  </Col>
                </div>
                <div className="d-flex my-2 align-items-center">
                  <Col xs={4} className="print-label">
                    Contact Person:
                  </Col>
                  <Col xs={5} className="print-data">
                    {printPI.contact_person}
                  </Col>
                </div>
                <div className="d-flex my-2 align-items-center">
                  <Col xs={4} className="print-label">
                    Contact No.:
                  </Col>
                  <Col xs={5} className="print-data">
                    {printPI.phone_no}
                  </Col>
                </div>
                <div className="d-flex my-2 align-items-center">
                  <Col xs={4} className="print-label">
                    Forwarder:
                  </Col>
                  <Col xs={5} className="print-data">
                    {printPI.forwarder_name}
                  </Col>
                </div>
                <div className="d-flex my-2 align-items-center">
                  <Col xs={4} className="print-label">
                    Date Received:
                  </Col>
                  <Col xs={6} className="print-data">
                    {dateFormat(printPI.supplies_receive_date)}
                  </Col>
                </div>
              </Col>

              <Col xs={6} lg={5} md={6} className="split-columns">
                <div className="d-flex my-2 align-items-center">
                  <Col xs={4} className="print-label">
                    Type:
                  </Col>
                  <Col xs={7} className="print-data">
                    {printPI.type}
                  </Col>
                </div>
                <div className="d-flex my-2 align-items-center">
                  <Col xs={4} className="print-label">
                    Invoice No.:
                  </Col>
                  <Col xs={6} className="print-data">
                    {printPI.invoice_no}
                  </Col>
                </div>
                <div className="d-flex my-2 align-items-center">
                  <Col xs={4} className="print-label">
                    Waybill No.:
                  </Col>
                  <Col xs={6} className="print-data">
                    {printPI.waybill_no}
                  </Col>
                </div>
                <div className="d-flex my-2 align-items-center">
                  <Col xs={4} className="print-label">
                    DR No.:
                  </Col>
                  <Col xs={6} className="print-data">
                    {printPI.dr_no}
                  </Col>
                </div>
                <div className="d-flex my-2 align-items-center">
                  <Col xs={4} className="print-label">
                    Remarks:
                  </Col>
                  <Col xs={6} className="print-data">
                    {printPI.remarks}
                  </Col>
                </div>
                <div className="d-flex my-2 align-items-center">
                  <Col xs={4} className="print-label">
                    {" "}
                  </Col>
                  <Col xs={6} className="print-data"></Col>
                </div>
              </Col>
            </Row>
            <Row className="single-column">
              <Col xs={12}>
                <div className="d-flex my-2 align-items-center">
                  <Col xs={4} className="print-label">
                    Branch:
                  </Col>
                  <Col xs={5} className="print-data">
                    {printPI.branch_name}
                  </Col>
                </div>
                <div className="d-flex my-2 align-items-center">
                  <Col xs={4} className="print-label">
                    Contact Person:
                  </Col>
                  <Col xs={5} className="print-data">
                    {printPI.contact_person}
                  </Col>
                </div>
                <div className="d-flex my-2 align-items-center">
                  <Col xs={4} className="print-label">
                    Contact No.:
                  </Col>
                  <Col xs={5} className="print-data">
                    {printPI.phone_no}
                  </Col>
                </div>
                <div className="d-flex my-2 align-items-center">
                  <Col xs={4} className="print-label">
                    Forwarder:
                  </Col>
                  <Col xs={5} className="print-data">
                    {printPI.forwarder_name}
                  </Col>
                </div>
                <div className="d-flex my-2 align-items-center">
                  <Col xs={4} className="print-label">
                    Date Received:
                  </Col>
                  <Col xs={6} className="print-data">
                    {dateFormat(printPI.supplies_receive_date)}
                  </Col>
                </div>
              </Col>

              <Col xs={12}>
                <div className="d-flex my-2 align-items-center">
                  <Col xs={4} className="print-label">
                    Type:
                  </Col>
                  <Col xs={7} className="print-data">
                    {printPI.type}
                  </Col>
                </div>
                <div className="d-flex my-2 align-items-center">
                  <Col xs={4} className="print-label">
                    Invoice No.:
                  </Col>
                  <Col xs={6} className="print-data">
                    {printPI.invoice_no}
                  </Col>
                </div>
                <div className="d-flex my-2 align-items-center">
                  <Col xs={4} className="print-label">
                    Waybill No.:
                  </Col>
                  <Col xs={6} className="print-data">
                    {printPI.waybill_no}
                  </Col>
                </div>
                <div className="d-flex my-2 align-items-center">
                  <Col xs={4} className="print-label">
                    DR No.:
                  </Col>
                  <Col xs={6} className="print-data">
                    {printPI.dr_no}
                  </Col>
                </div>
                <div className="d-flex my-2 align-items-center">
                  <Col xs={4} className="print-label">
                    Remarks:
                  </Col>
                  <Col xs={6} className="print-data">
                    {printPI.remarks}
                  </Col>
                </div>
                <div className="d-flex my-2 align-items-center">
                  <Col xs={4} className="print-label">
                    {" "}
                  </Col>
                  <Col xs={6} className="print-data"></Col>
                </div>
              </Col>
            </Row>

            <div className="d-flex mt-1 mb-2 justify-content-evenly">
              {/* table */}
              <div className="print-table mt-3 mx-2">{renderTable()}</div>
            </div>

            <Row className="mt-2">
              <span className="print-footer">Remarks{printPI.remarks}</span>
            </Row>
            <Row className="print-grand-total my-3 text-end">
              <Col xs={8} lg={9} md={6} className="print-table-footer-label">
                SUBTOTAL
              </Col>
              <Col
                xs={2}
                lg={3}
                md={3}
                className="print-table-footer-data text-end"
              >
                {printPI.subtotal ? numberFormat(printPI.subtotal) : "0.00"}
              </Col>
            </Row>
            <Row className="print-grand-total my-3 text-end">
              <Col xs={8} lg={9} md={6} className="print-table-footer-label">
                DISCOUNT
              </Col>
              <Col
                xs={2}
                lg={3}
                md={3}
                className="print-table-footer-data text-end"
              >
                {printPI.discount ? numberFormat(printPI.discount) : "0.00"}
              </Col>
            </Row>
            <Row className="print-grand-total my-3 text-end">
              <Col xs={8} lg={9} md={6} className="print-table-footer-label">
                DISCOUNT SUBTOTAL
              </Col>
              <Col
                xs={2}
                lg={3}
                md={3}
                className="print-table-footer-data text-end"
              >
                {printPI.discounted_subtotal
                  ? numberFormat(printPI.discounted_subtotal)
                  : "0.00"}
              </Col>
            </Row>
            {printPI.vat_type === "VAT" && (
              <>
                <Row className="print-grand-total my-3 text-end">
                  <Col
                    xs={8}
                    lg={9}
                    md={6}
                    className="print-table-footer-label"
                  >
                    VAT
                  </Col>
                  <Col
                    xs={2}
                    lg={3}
                    md={3}
                    className="print-table-footer-data text-end"
                  >
                    {printPI.vat ? numberFormat(printPI.vat) : "0.00"}
                  </Col>
                </Row>
                <Row className="print-grand-total my-3 text-end">
                  <Col
                    xs={8}
                    lg={9}
                    md={6}
                    className="print-table-footer-label"
                  >
                    VATABLE SALES
                  </Col>
                  <Col
                    xs={2}
                    lg={3}
                    md={3}
                    className="print-table-footer-data text-end"
                  >
                    {printPI.vatable_sales
                      ? numberFormat(printPI.vatable_sales)
                      : "0.00"}
                  </Col>
                </Row>
                <Row className="print-grand-total my-3 text-end">
                  <Col
                    xs={8}
                    lg={9}
                    md={6}
                    className="print-table-footer-label"
                  >
                    WHT({numberFormatInt(printPI.withholding_percentage)} %)
                  </Col>
                  <Col
                    xs={2}
                    lg={3}
                    md={3}
                    className="print-table-footer-data text-end"
                  >
                    {printPI.withholding_tax
                      ? numberFormat(printPI.withholding_tax)
                      : "0.00"}
                  </Col>
                </Row>
              </>
            )}
            <Row className="print-grand-total my-3 text-end">
              <Col xs={8} lg={9} md={6} className="print-table-footer-label">
                GRAND TOTAL
              </Col>
              <Col
                xs={2}
                lg={3}
                md={3}
                className="print-table-footer-data text-end"
              >
                {printPI.grandtotal_without_service_fee
                  ? numberFormat(printPI.grandtotal_without_service_fee)
                  : "0.00"}
              </Col>
            </Row>
            <Row className="print-grand-total my-3 text-end">
              <Col xs={8} lg={9} md={6} className="print-table-footer-label">
                DELIVERY/SERVICE FEE
              </Col>
              <Col
                xs={2}
                lg={3}
                md={3}
                className="print-table-footer-data text-end"
              >
                {printPI.service_fee || "0.00"}
              </Col>
            </Row>
            <Row className="print-grand-total my-3 text-end">
              <Col
                xs={8}
                lg={9}
                md={6}
                className="bold print-table-footer-label"
              >
                TOTAL AMOUNT DUE
              </Col>
              <Col
                xs={2}
                lg={3}
                md={3}
                className="bold print-table-footer-data text-end"
              >
                {printPI.grand_total
                  ? numberFormat(printPI.grand_total)
                  : "0.00"}
              </Col>
            </Row>
            <div className="mt-5">
              <Row className="mt-5 d-flex flex-row align-items-end justify-content-evenly">
                <Col
                  xs={3}
                  className="print-sig justify-content-center align-items-center d-flex flex-column"
                >
                  <img
                    src={printPI.prepared_by_name_signature}
                    className="signature-size"
                    alt=""
                  />
                  <p className="print-data underline-border text-center">
                    {printPI.prepared_by}
                  </p>
                  <p className="print-data text-center mt-2">Prepared by</p>
                </Col>
                <Col
                  xs={3}
                  className="print-sig justify-content-center d-flex flex-column"
                >
                  {/* <img
                    src={printPI.prepared_by_name_signature}
                    className="signature-size"
                    alt=""
                  /> */}
                  <p className="print-data underline-border text-center">
                    {printPI.approved_by}
                  </p>
                  <p className="print-data text-center mt-2">
                    Noted by (Receiver)
                  </p>
                </Col>
              </Row>
            </div>
          </div>
        </div>
        <div className="mt-4 noPrint mx-3">
          <Row className="review-data mb-2">FILE ATTACHMENTS</Row>
          <Row className="">
            {fileList &&
              fileList.map((attachment) => (
                <Col
                  xs={1}
                  onClick={() => {
                    setPreviewFile(attachment.file_url)
                    setPreview(true)
                  }}
                  className="cursor-pointer preview-container"
                >
                  <img src={attachment.file_url} className="img-preview" />
                </Col>
              ))}
            {!fileList ||
              (fileList.length === 0 && (
                <Col xs={1}>
                  <div className="no-data-cont d-flex justify-content-left preview-container">
                    <img
                      src={noDataImg}
                      alt="no data found"
                      className="img-preview"
                    />
                  </div>
                </Col>
              ))}
          </Row>
        </div>
        <br />
        <div>
          <h5 className="PI-payment-info">PAYMENT INFO</h5>
          <div className="tab-content">
            <TablePagination
              tableHeaders={[
                "PAYMENT DATE",
                "TYPE",
                "DETAILS",
                "PAYMENT AMOUNT",
                "AMOUNT APPLIED TO INV",
              ]}
              headerSelector={[
                "payment_date",
                "type",
                "details",
                "amount",
                "amount_applied_to_invoice",
              ]}
              tableData={paymentInfo}
            />
          </div>
        </div>

        {/* footer */}
        <div className="d-flex justify-content-end my-4 d-flex-responsive">
          <button
            className="button-secondary me-2"
            onClick={() => navigate("/se/purchaseinvoices")}
          >
            Close
          </button>
          <button
            className="button-tertiary me-2"
            onClick={() => navigate("/se/purchaseinvoices/edit/" + id)}
          >
            Edit
          </button>
          <button className="button-primary" onClick={handleShowPrintModal}>
            Print
          </button>
        </div>
        <br />
        <br />
      </div>
      {/* modals */}
      <PIModal
        show={showPrintModal}
        hide={handleClosePrintModal}
        type="print"
        handler={handlePrintPI}
      />
      <Modal
        open={preview}
        title={""}
        footer={null}
        onCancel={() => setPreview(false)}
      >
        <img
          alt="example"
          style={{
            width: "100%",
          }}
          src={previewFile}
        />
      </Modal>
      <Footer />
    </div>
  )
}
